@let referentiel = this.referentiel();
@if (referentiel) {
  <hlm-resizable-group class="flex size-full">
    <hlm-resizable-panel
      class="m-lg border-stroke-neutral-light bg-background-ground flex flex-col rounded-lg border"
      defaultSize="30"
    >
      <div class="border-stroke-neutral-light p-md flex items-center justify-between border-b">
        <div class="gap-sm flex items-center">
          <p class="title-small-semibold text-content-primary">Ressources professionnelles</p>
          @if (estVerrouille()) {
            <app-chip label="Verrouillé" variant="warning" />
          }
        </div>
      </div>
      <div class="pt-md h-full overflow-y-auto">
        @if (aptitudes().length < 1 && !peutModifier()) {
          <app-empty-state title="Pas de processus disponible">
            <span class="text-content-secondary text-center">
              Il semble que rien n’ait été renseigné pour le Processus. Contactez l’administrateur pour déverrouiller le
              Référentiel et ajouter des éléments.
            </span>
          </app-empty-state>
        } @else if (aptitudes().length < 1 && peutModifier()) {
          <div class="text-center">
            <app-empty-state title="Aucune aptitude" icone="lucideLayers">
              <span class="text-content-secondary text-center">
                Définissez d'abord vos aptitudes et productions dans la page Processus.
              </span>
              <button (click)="navigateToProcessus()" hlmBtn variant="secondary">
                <ng-icon name="lucideArrowLeft" />
                Retourner au Processus
              </button>
            </app-empty-state>
          </div>
        } @else {
          <app-list-item gap="16px">
            @for (aptitude of aptitudes(); track aptitude.id; let last = $last) {
              <app-aptitude-item
                [aptitude]="aptitude"
                [peutModifier]="peutModifier()"
                [cartographie]="cartographie()"
              />
              @if (!last) {
                <hlm-separator />
              }
            }
          </app-list-item>
        }
      </div>
    </hlm-resizable-panel>
    <hlm-resizable-handle />
    <hlm-resizable-panel defaultSize="70">
      <div class="bg-background-ground border-stroke-neutral-light h-full border-l">
        @if (productionSelected() === undefined) {
          <app-empty-state title="Aucune production sélectionnée" icone="lucideMousePointerClick">
            <span class="text-content-secondary text-center"
              >Sélectionnez une production pour afficher ses ressources professionnelles, et pour en créer de
              nouvelles.</span
            >
          </app-empty-state>
        } @else if (productionSelected(); as production) {
          <app-ressources-professionnelles-list
            [production]="productionSelected()!"
            [cartographie]="cartographie()"
            [peutModifier]="peutModifier()"
          >
          </app-ressources-professionnelles-list>
        }
      </div>
    </hlm-resizable-panel>
  </hlm-resizable-group>
}
